export default __webpack_public_path__ + "static/media/jaktur.ac590b54.png";